<form [formGroup]="fGroup">
  <div [formGroupName]="fgName">
    <ng-content></ng-content>
  </div>
</form>
